export function todayString(date) {
    var todayUTC = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
    return todayUTC.toISOString().slice(0, 10);
}
export function toLocaleDate(day) {
    return new Date(Date.UTC(day.getFullYear(), day.getMonth(), day.getDate()));
}
export function areDateEquals(a, b) {
    return a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth() && a.getDate() === b.getDate();
}



//////////////////
// WEBPACK FOOTER
// ./src/utils/dates.ts
// module id = 37
// module chunks = 0